import * as React from 'react'
import { connect } from 'react-redux'
import type { Dispatch } from 'redux'
import HtmlHead from '../components/HtmlHead'
import type { AppStateType } from '../reducers/appstate'
import { withRouter } from 'next/router'
import { GlobalStyle } from '@components/shared'
import { colors } from '../components/shared/colors'
import TopNav from '@components/TopNav'
import Footer from '@components/Footer'
import TopNavMobile from '@components/TopNavMobile'
import AboutHeaderSection from '@components/about/AboutHeaderSection'
import OurBeliefs from '@components/about/OurBeliefs'
import OurPeople from '@components/about/OurPeople'
import OurFounders from '@components/about/OurFounders'

function About (): React.ReactNode {
  function takeMeThere (id: string): void {
    const element = window.document.getElementById(id)
    SmoothVerticalScrolling(element as HTMLHtmlElement, 300, id)
  }

  function SmoothVerticalScrolling (
    e: HTMLHtmlElement,
    time: number,
    id: string
  ): void {
    try {
      new Promise<void>((resolve): void => {
        const eTop = e.getBoundingClientRect().top
        const eAmt = eTop / 100
        let curTime = 0
        const promises: any[] = []
        while (curTime <= time) {
          promises.push(
            new Promise<void>((resolve): void => {
              window.setTimeout(
                function initScroll (): void {
                  window.scrollBy(0, eAmt)
                  resolve()
                },
                curTime,
                eAmt
              )
            })
          )
          curTime += time / 100
        }
        Promise.all(promises).then((): void => {
          resolve()
        })
      }).then((): void => {
        window.location.hash = `#${id}`
      })
    } catch (error) {
      window.location.hash = `#${id}`
    }
  }

  const [isAssetLoaded, setIsAssetLoaded] = React.useState < boolean >(false)
  return (
    <>
      <HtmlHead
        title={'Dipsea | About'}
        description={
          'We\'re a women-led team creating a safe space for everyone to explore their desires.'
        }
      />
      <GlobalStyle backgroundColor={colors.midnightBlue} />
      <TopNav backgroundColor={colors.midnightBlue95} isAssetLoaded={true} />
      <TopNavMobile
        backgroundColor={colors.midnightBlue95}
        isAssetLoaded={true}
      />
      <AboutHeaderSection
        setLoadingComplete={(): void => setIsAssetLoaded(true)}
        takeMeThere={(id: string): void => takeMeThere(id)}
        isMenuVisible={isAssetLoaded}
      />
      {isAssetLoaded && <OurBeliefs />}
      {isAssetLoaded && <OurPeople />}
      {isAssetLoaded && <OurFounders />}
      {isAssetLoaded && <Footer />}
    </>
  )
}

const mapStateToProps = (_state: AppStateType): any => {
  return {}
}

const mapDispatchToProps = (_dispatch: Dispatch<any>): any => {
  return {}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(About) as any) as any
